// src/lib.tsx
import { isMatch } from "lodash-es";
function mergeExecutors(oldExecutors, newExecutors) {
  return [...oldExecutors, ...newExecutors];
}
function matchVariables(matcher, variables) {
  if (typeof matcher === "undefined") {
    return true;
  }
  if (typeof matcher === "function") {
    return matcher(variables);
  }
  return isMatch(variables, matcher);
}
function formatEntry(id, variables) {
  return `${id ? id : "*"}:${variables ? JSON.stringify(variables) : "*"}`;
}
function findExecutors(registry, id, variables) {
  return registry.filter(
    (entry) => (id === entry.id || entry.id === void 0) && matchVariables(entry.variables, variables)
  ).map((entry) => entry.executor);
}
function findExecutor(registry, id, variables) {
  const result = findExecutors(registry, id, variables);
  if (result.length > 0) {
    return result.pop();
  }
  throw new ExecutorRegistryError(registry, id, variables);
}
var ExecutorRegistryError = class extends Error {
  constructor(registry, id, variables) {
    const candidates = registry.filter((entry) => id === entry.id);
    const candidatesMessage = candidates.length > 0 ? [
      "Candidates:",
      ...candidates.map(
        ({ id: id2, variables: variables2 }) => formatEntry(id2, variables2)
      )
    ] : [];
    super(
      [
        "No executor found for:",
        formatEntry(id, variables),
        ...candidatesMessage
      ].join(" ")
    );
    this.name = "ExecutorRegistryError";
  }
};

export {
  mergeExecutors,
  findExecutors,
  findExecutor
};
